export default __webpack_public_path__ + "static/media/OrangeBackgroundHeader.b13c8e96.png";